<template>
<div>
    <h4>Loading...</h4>
</div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'PageRender',
  methods: {
    render() {
      if (localStorage.userID) {
        const path = `${this.$hostname}/check-page/${localStorage.userID}`;
        axios
          .get(path)
          .then((res) => {
            if (res.data.status === 'success') {
              if (!res.data.isLoggedIn) {
                this.$router.push({ path: '/login' });
              } else {
                localStorage.userID = res.data.userID;
                localStorage.taskID = res.data.taskID;
                localStorage.userType = res.data.userType;
                localStorage.firstName = res.data.workerID;
                localStorage.accountProgress = res.data.accountProgress;
                if (localStorage.accountProgress === 'Task') {
                  this.$router.push({ name: 'Task' });
                } else if (localStorage.accountProgress === 'Demographic') {
                  this.$router.push({ name: 'Demographic' });
                } else if (localStorage.accountProgress === 'ExitQuestion') {
                  this.$router.push({ name: 'ExitQuestion' });
                } else if (localStorage.accountProgress === 'Finish') {
                  this.$router.push({ name: 'Finish' });
                } else {
                  this.$router.push({ name: 'Signup' });
                }
              }
            } else {
              alert('Server error! Please Log in again!');
              this.$router.push({ path: '/login' });
            }
          });
      }
    },
  },
  created() {
    this.render();
  },
};
</script>
